import { Box, IconButton, Typography } from "@mui/material";
import { CloseSVG } from "./CloseSVG";
import LinearDeterminate from "./LinearProgress";

const FileItem = ({ doc, deleteFile, showProgress = false }) => {
  const getDoctype = (doc) => {
    const list = doc.split(".");
    return list[list.length - 1].toUpperCase();
  };

  return (
    <Box>
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: "20px",
          borderBottom: "1px solid #F3F3F7",
          marginTop: "32px",
        })}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          })}
        >
          <Box
            sx={(theme) => ({
              display: "inline-flex",
              padding: "12px 8px 10px 8px",
              justifyContent: "center",
              alignItems: "center",
              color: "#2B2D33",
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "18px",
              borderRadius: "8px",
              backgroundColor: "#E7E7EC",
              marginRight: "16px",
            })}
          >
            {getDoctype(doc?.fileName)}
          </Box>
          <Box>
            <Typography
              sx={(theme) => ({
                color: "#2B2D33",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "22px",
              })}
            >
              {doc?.fileName}
            </Typography>
            {/* <Typography
        sx={(theme) => ({
          color: "#AAABAD",
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "18px",
        })}
      >
        21.03.2017, 16:04:34 • 589 Кб
      </Typography> */}
          </Box>
        </Box>
        {!showProgress && (
          <IconButton
            aria-label="delete"
            onClick={async () => {
              await deleteFile(doc?.id);
            }}
            sx={(theme) => ({})}
          >
            <CloseSVG width={16} height={16} />
          </IconButton>
        )}
      </Box>
      {showProgress && <LinearDeterminate />}
    </Box>
  );
};

export default FileItem;
